export default "__VITE_ASSET__Cns6tTXz__"